// WorkspaceSwitcherV2 (SaaS) — bản ĐẤU NỐI cho cụm dùng chung
// @cnv/ui/layout/WorkspaceSwitcherV2.
//
// Toàn bộ giao diện + luồng đổi workspace nằm ở kernel (hai hệ SaaS chung MỘT bản — xem chú
// thích đầy đủ trong tệp đó). Ở đây chỉ còn những mảnh THẬT SỰ riêng của cụm này:
//
//   • kho phiên: authApi + useAuthStore của host này
//   • MÔ HÌNH GÓI: bậc gói là SỐ (`meta.plans.tier_level` 0/1/2) và tên gói phải đi qua
//     BẢNG TÊN SẢN PHẨM (`marketplace/planCopy`) — in thẳng `plan_label` của BE thì header
//     ghi "CNV Work On Cloud · All-in-one" còn /marketplace ghi "On-Cloud All-in-one", hai
//     tên cho một gói cách nhau đúng một màn hình, và bản EN lòi tiếng Việt (chuỗi BE không
//     đi qua Lingui). Cùng lý do với PlanBadgeV2.
//
// `usePlanName` là HOOK nên không gọi được cho từng dòng trong danh sách (số lần gọi hook
// đổi theo độ dài danh sách = vi phạm Rules of Hooks, lint:hooks chặn). Dùng
// `usePlanNameLookup()` — gọi hook một lần, trả về hàm thường; kernel chỉ cần
// `planLabelOf(row) => string`.
//
// Viên nhãn gói trên nút đọc từ query `['seat-status']` — ĐÚNG khoá mà PlanBadgeV2 (cùng
// thanh) và BillingPage dùng ⇒ về từ cache, KHÔNG phát sinh request thứ hai.

import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import WorkspaceSwitcher from '@cnv/ui/layout/WorkspaceSwitcherV2';
import { authApi, planApi } from '../../lib/inboxClient';
import { useAuthStore } from '../../lib/authStore';
import { usePlanName, usePlanNameLookup } from '../../marketplace/planCopy';

export default function WorkspaceSwitcherV2() {
  const navigate = useNavigate();
  const activeTenant = useAuthStore((s) => s.activeTenant);
  const applySwitchTenant = useAuthStore((s) => s.applySwitchTenant);

  const { data: seat } = useQuery({
    queryKey: ['seat-status'],
    queryFn: () => planApi.seatStatus(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  const currentPlanName = usePlanName(seat?.plan_code, seat?.plan_label);
  const nameOf = usePlanNameLookup();

  return (
    <WorkspaceSwitcher
      activeTenant={activeTenant}
      currentPlan={seat?.plan_code
        ? { label: currentPlanName, tier: seat.plan_tier_level ?? '' }
        : null}
      listTenants={() => authApi.listMyTenants()}
      switchTenant={(id) => authApi.switchTenant(id)}
      // Token + workspace + `user` (tên/ảnh, vai trò + quyền CỦA WORKSPACE MỚI) — một cửa chung
      // với màn /select-workspace. Kernel tự tải lại trang ngay sau đó.
      applySession={applySwitchTenant}
      planLabelOf={(row) => (row.plan_code ? nameOf(row.plan_code, row.plan_label) : null)}
      onSeeAll={() => navigate('/select-workspace')}
    />
  );
}
